// your.component.ts
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-file-icon',
  templateUrl: './file-icon.component.html',
  styleUrls: ['./file-icon.component.css'],
})
export class FileIconComponent {
  @Input() fillColor = '#ef2f32';
}
